import type { JSX } from 'react';

import { Col, Row } from 'antd';

import { MTooltip } from '../MTooltip/MTooltip';

import * as Styles from './MFormRadioGroupField.styles';

interface MFormRadioGroupFieldProps {
  label: string;
  value?: JSX.Element | string | number;
  description?: JSX.Element | string;
  weight?: 'light' | 'medium';
  alignment: 'horizontal' | 'vertical';
  tooltip?: {
    type: 'popover' | 'modal';
    title?: string;
    content?: string;
  };
  testId?: string;
}

export const MFormRadioGroupField = ({
  label,
  value,
  description,
  weight = 'medium',
  tooltip,
  testId,
}: MFormRadioGroupFieldProps) => (
  <Row className={Styles.container}>
    <Col span={24} className={Styles.label(weight)} data-testid={testId + '-label'}>
      {label}
    </Col>
    <Col span={24} className={Styles.value}>
      <span data-testid={testId + '-value'}>{value}</span>
      {tooltip && (
        <MTooltip type={tooltip.type} title={tooltip.title} data-testid={testId + '-tooltip'}>
          {tooltip.content}
        </MTooltip>
      )}
    </Col>
    {description && (
      <Col span={24} className={Styles.description} data-testid={testId + '-description'}>
        {description}
      </Col>
    )}
  </Row>
);
